import { useState, useEffect } from "react";
import { Link } from "react-scroll";

function Navbar() {
  const [navActive, setNavActive] = useState(false);

  const toggleNav = () => {
    setNavActive(!navActive);
  };

  const closeMenu = () => {
    setNavActive(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 500) {
        closeMenu;
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (window.innerWidth <= 1200) {
      closeMenu;
    }
  }, []);

  return (
    <nav className={`${navActive ? "active" : ""}`} style={{zIndex: '10'}}>
      <div className="noselect navbar" style={{zIndex: '10'}}>
      <div>
        <img src="./img/logoDPhead.jpg" style={{maxWidth: '11rem'}} alt="Directt Permis" />
      </div>
      <a
        className={`nav__hamburger ${navActive ? "active" : ""}`}
        onClick={toggleNav}
      >
        <span className="nav__hamburger__line"></span>
        <span className="nav__hamburger__line"></span>
        <span className="nav__hamburger__line"></span>
      </a>
      <div className={`navbar--items ${navActive ? "active" : ""}`}>
        <ul>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar--active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="landingPage"
              className="navbar--content"
            >
              <b>Accueil</b>
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar--active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="Formations"
              className="navbar--content"
            >
              <b>🎓 Formations</b>
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar--active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="Vehicules"
              className="navbar--content"
            >
              <b>🎫 Forfaits</b>
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar--active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="Agence"
              className="navbar--content"
            >
              <b>📍 Agence</b>
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar--active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="Avis"
              className="navbar--content"
            >
              <b>⭐ Avis</b>
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar--active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="Contact"
              className="navbar--content"
            >
              <b>📧 Contact</b>
            </Link>
          </li>
        </ul>
      </div>
      <a
        onClick={closeMenu}
        activeClass="navbar--active-content"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
        href="https://www.facebook.com/profile.php?id=100057400280350"
        target="_blank"
        className="btn btn-outline-primary-hide"
      >
        <b>Page Facebook</b>
      </a>
      </div>
      <div style={{marginTop: '5.3rem'}}>
        <p style={{backgroundColor: '#ef0f0f', textAlign: 'center', padding: '0.25rem', color: 'white'}}> Contacter Magalie au <b>📞 06 65 93 27 64</b> ou par email à <b>📧 m.directtpermis@gmail.com</b></p>
      </div>
    </nav>
  );
}

export default Navbar;
